import React, { useState } from 'react';

const ApplyNow = () => {
  // State to control modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to handle the button click, opening the form in a modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {/* Apply Now Button */}
     
      <div className="flex justify-center">
              <button
                className=" font-fancy font-bold inline-flex border-0 py-2 px-4 focus:outline-none bg-[#d6b055] hover:bg-[#010000f5] hover:text-white  text-black rounded "
                onClick={openModal}
                 >
                APPLY NOW
              </button>
            </div>
        
     

      {/* Modal to Display Google Form */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full sm:w-3/4 lg:w-1/2">
            <h2 className="text-xl font-semibold md:mb-2 custom-xsm:mb-5">Application Form</h2>
            {/* Embed Google Form */}
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSdOztyp1_VkfV1piz81r3aL3AWyXxoPSWbODQcuCl6XMC1S8w/viewform?embedded=true"
              width="100%"
              height="500"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              className="mb-4"
              title="Google Application Form"
            >
              Loading…
            </iframe>
            <button
              className="bg-red-500 text-white px-4 py-2 mb-1 ml-3 rounded-full hover:bg-red-600"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplyNow;
